import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { AnalyticsImageData } from '~types/index'

const onBannerLoadedInit = (clientId: string) => (data: AnalyticsImageData) => {
  trackEvent({
    eventName: 'view_banner',
    data: {
      clientId,
      creative_name: data?.title || null,
      banner_id: data?.id || null,
      url: data?.src || null,
      creative_slot: data?.creative_slot || null,
    },
  })
}

export default onBannerLoadedInit
